export const BASE_URL = "https://socket.kallout.io/api";

const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

/**
 * Dedicated API Client for Event Socket Service (Stream Backend)
 */
const streamApiClient = async (endpoint: string, options: RequestInit = {}) => {
  try {
    const url = `${BASE_URL}${endpoint}`;

    // Merge headers
    const headers = {
      ...defaultHeaders,
      ...(options.headers || {}),
    };

    const config = {
      ...options,
      headers,
    };

    const response = await fetch(url, config);
    const data = await response.json();

    if (!response.ok) {
      // Handle NestJS standard error format
      const errorMessage = data.message || data.error || "Something went wrong";
      throw new Error(
        Array.isArray(errorMessage) ? errorMessage[0] : errorMessage
      );
    }

    return data;
  } catch (error: any) {
    console.error("Stream API Error:", error.message);
    throw error;
  }
};

export default streamApiClient;
